import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { menuPlanService } from "../services/menuPlan.service";

export const fetchMenuPlans = createAsyncThunk(
  "menuPlan/fetch",
  async ({ shopId, from, to }, thunkAPI) => {
    try {
      return await menuPlanService.getMenuPlans(shopId, from, to);
    } catch (err) {
      return thunkAPI.rejectWithValue("Failed");
    }
  },
);

export const fetchAllMenuPlans = createAsyncThunk(
  "menuPlan/fetchAll",
  async (_, thunkAPI) => {
    try {
      return await menuPlanService.getAllMenuPlans();
    } catch (err) {
      return thunkAPI.rejectWithValue("Failed");
    }
  },
);

export const addMenuPlan = createAsyncThunk(
  "menuPlan/add",
  async (plan, thunkAPI) => {
    try {
      return await menuPlanService.createMenuPlan(plan);
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data?.message || "Failed");
    }
  },
);

export const removeMenuPlan = createAsyncThunk(
  "menuPlan/remove",
  async (id, thunkAPI) => {
    try {
      await menuPlanService.deleteMenuPlan(id);
      return id;
    } catch (err) {
      return thunkAPI.rejectWithValue("Failed");
    }
  },
);

const menuPlanSlice = createSlice({
  name: "menuPlan",
  initialState: { plans: [], loading: false, error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMenuPlans.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchMenuPlans.fulfilled, (state, action) => {
        state.loading = false;
        state.plans = action.payload;
      })
      .addCase(fetchMenuPlans.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchAllMenuPlans.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAllMenuPlans.fulfilled, (state, action) => {
        state.loading = false;
        state.plans = action.payload;
      })
      .addCase(fetchAllMenuPlans.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(addMenuPlan.fulfilled, (state, action) => {
        state.plans.push(...action.payload); // spread car payload est un tableau
      })
      .addCase(removeMenuPlan.fulfilled, (state, action) => {
        state.plans = state.plans.filter(
          (p) => p.menuPlanId !== action.payload,
        );
      });
  },
});
export default menuPlanSlice.reducer;
